import { AubadeComponent } from "js/front/bootstrap";
import { gsap } from "gsap";

import { APP_PATH } from "js/common/AppUrl";

class SizeAndStyle extends AubadeComponent {
    #currentStyle = "tous";
    #currentType = "sdb";
    #gridTl;
    #lastOpenCard = null;
    #isChanging = false;
    #cardTl = null;

    constructor(e, b) {
        super(e, b);

        this.title = e.querySelector("h1");

        this.types = [...e.querySelectorAll(".type")];
        this.typesC = e.querySelector(".types");
        this.typesSticky = e.querySelector(".types-sticky");

        this.cardsC = e.querySelector(".cards-c");
        this.cards = [...e.querySelectorAll(".card")];
        this.itemsSize = [...e.querySelectorAll(".size")];
        this.cardsData = this.cards.map(card => {
            return {
                el: card,
                // cardParallax: card.querySelector(".card-parallax"),
                content: card.querySelector(".content"),
                contentTop: card.querySelector(".content .top"),
                pictureW: card.querySelector(".picture-w"),
                img: card.querySelector(".picture-w img"),
                sizesW: card.querySelector(".sizes-w"),
                sizes: card.querySelector(".sizes"),
                sizesTop: card.querySelector(".sizes-w .top"),
                isOpen: false,
                cardPTlEnter: null,
                cardPTlLeave: null,
                imgPTl: null,
                displayed: true
            };
        });
        this.header = this.bootstrap.components.get(
            document.querySelector("header")
        );
    }

    init() {
        if (this.types.length === 0) return;
        const urlParams = this.getParametersFromUrl();
        this.#currentStyle = urlParams[0];
        this.#currentType = urlParams[1];

        this.types.forEach(type => {
            type.classList.toggle(
                "active",
                type.dataset.slug === this.#currentType
            );
        });
    }

    attach() {
        window.scrollTo(0, 0);

        this.viewport.on("resize", this.onResize);

        if (this.types.length > 0) {
            this.routeCustom = this.bootstrap.router.add(
                "type/{type}",
                this.onRouteChange
            );

            this.types.forEach(type =>
                type.addEventListener("click", this.onTypeClick)
            );
        }

        this.cardsData.forEach(card => {
            card.el.addEventListener("click", this.onCardClick, true);
        });

        this.itemsSize.forEach(size => {
            size.addEventListener("click", this.onItemClick);
        });

        if (this.types.length > 0) this.setupStickyChoice();
    }

    detach() {
        this.viewport.off("resize", this.onResize);

        if (this.routeCustom) {
            this.bootstrap.router._crossroads.removeRoute(this.routeCustom);
            this.routeCustom = null;
        }
        if (this.types.length > 0) {
            this.types.forEach(type =>
                type.removeEventListener("click", this.onTypeClick)
            );

            this.cardsData.forEach(card => {
                card.el.removeEventListener("click", this.onCardClick);
            });
        }

        this.itemsSize.forEach(size => {
            size.removeEventListener("click", this.onItemClick, true);
        });
    }

    onResize = () => {};

    open() {
        this.header.openHeaderNotHome();

        let delay = 0;
        if (!this.router.previous) {
            delay = 0.56;
        }

        const tl = gsap.timeline({ delay: delay });

        this.cardsData.forEach((card, i) => {
            if (card.el.dataset.type !== this.#currentType) {
                card.el.style.display = "none";
                card.isOpen = false;
                card.displayed = false;

                this.cardsC.appendChild(card.el);
            } else {
                card.el.style.display = "flex";
            }

            tl.fromTo(
                card.img,
                { opacity: 0 },
                {
                    opacity: 1,
                    duration: 0.8,
                    ease: "power2.out"
                },
                0.4 + 0.05 * i + 0.8
            );
        });

        // Size and style Page
        if (this.types.length > 0) {
            tl.fromTo(
                this.title,
                { y: window.innerHeight },
                { y: 0, duration: 0.8, ease: "power2.out" },
                0
            );

            tl.fromTo(
                this.element.querySelector(".description-w"),
                { y: window.innerHeight },
                { y: 0, duration: 1, ease: "power2.out" },
                0
            );

            tl.fromTo(
                this.types,
                { y: window.innerHeight },
                { y: 0, duration: 1, ease: "power2.out" },
                0
            );

            tl.fromTo(
                this.cards,
                { y: window.innerHeight },
                {
                    y: 0,
                    duration: 1.2,
                    stagger: "0.05",
                    ease: "power2.out"
                },
                0
            );
            this.cardsData.forEach((card, i) => {
                tl.add(() => {
                    if (card.displayed) {
                        this.updateCardParallax(card);
                    }
                }, 0.4 + 0.05 * i + 0.8);
            });
        }
        // SEO Page
        else {
            tl.fromTo(
                this.title,
                { y: window.innerHeight },
                { y: 0, duration: 1.2, ease: "power2.out" },
                0
            );
            tl.fromTo(
                this.element.querySelectorAll(".description"),
                { y: window.innerHeight },
                { y: 0, duration: 1.2, ease: "power2.out" },
                0.2
            );
            tl.fromTo(
                this.cards,
                { y: window.innerHeight },
                {
                    y: 0,
                    duration: 1.2,
                    stagger: "0.05",
                    ease: "power2.out"
                },
                0.4
            );
        }

        return tl;
    }

    getParametersFromUrl = () => {
        const pathName = this.router.current.relative;
        // Remove query parameters
        const cleanPath = pathName.split("?")[0];
        return cleanPath.replace(/^\//, "").split("/");
    };

    updateUrl() {
        this.router.set(`type/${this.#currentType}`);
    }

    onRouteChange = () => {
        window.history.pushState(
            "",
            "",
            `${APP_PATH}/type/${this.#currentType}`
        );

        this.updateGrid();
    };

    updateGrid = () => {
        window.scrollTo(0, 0);

        this.#gridTl?.kill();
        this.#gridTl = gsap.timeline();

        this.#gridTl.to(this.cardsC, { opacity: 0, duration: 0.2 }, 0);

        this.#gridTl.add(() => {
            this.cardsData.forEach(card => {
                if (card.el.dataset.type !== this.#currentType) {
                    card.el.style.display = "none";
                    card.isOpen = false;
                    card.displayed = false;

                    this.cardsC.appendChild(card.el);
                } else {
                    card.el.style.display = "flex";
                    card.displayed = true;
                }
            });
        }, 0.2);

        this.#gridTl.to(this.cardsC, { opacity: 1, duration: 1 }, 0.5);

        this.#gridTl.add(() => {
            this.cardsData.forEach(card => {
                if (card.displayed) {
                    this.updateCardParallax(card);
                }
            });
        }, 0.2);
    };

    updateCardParallax = card => {
        // Card enter bottom parallax
        card.cardPTlEnter?.kill();
        card.cardPTlEnter = gsap.timeline({
            scrollTrigger: {
                trigger: card.el,
                start: "top bottom",
                end: "50% bottom",
                scrub: true
            }
        });
        card.cardPTlEnter.fromTo(
            card.el,
            { y: 30 },
            {
                y: 0,
                ease: "none"
            }
        );

        // Card leave top parallax
        card.cardPTlLeave?.kill();
        card.cardPTlLeave = gsap.timeline({
            scrollTrigger: {
                trigger: card.el,
                start: "50% top",
                end: "bottom top",
                scrub: true
            }
        });
        card.cardPTlLeave.fromTo(
            card.el,
            { y: 0 },
            {
                y: -30,
                ease: "none"
            }
        );

        // Image parallax
        card.imgPTl?.kill();
        card.imgPTl = gsap.timeline({
            scrollTrigger: {
                trigger: card.el,
                start: "top 80%",
                end: "bottom top",
                scrub: true
            }
        });
        card.imgPTl.fromTo(
            card.img,
            { y: -50 },
            {
                y: 50,
                ease: "none"
            }
        );
    };

    setupStickyChoice = () => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.typesC,
                toggleActions: "play none none reset",
                start: "bottom top",
                end: "bottom top"
            }
        });

        tl.fromTo(this.typesSticky, { opacity: 0 }, { opacity: 1 });
    };

    onTypeClick = e => {
        const type = e.currentTarget.dataset.slug;

        if (type === this.#currentType) return;
        this.#currentType = type;

        this.types.forEach(type => type.classList.toggle("active"));

        this.updateUrl();
    };

    onCardClick = e => {
        if (
            (e.target.classList.contains("size") ||
                this.#currentType !== "sdb") &&
            this.types.length > 0
        )
            return;

        const index = this.cards.indexOf(e.currentTarget);
        const selectedCard = this.cardsData[index];

        if (this.#isChanging) return;
        this.#isChanging = true;

        this.#cardTl?.kill();
        this.#cardTl = gsap.timeline();

        if (!selectedCard.isOpen) {
            selectedCard.isOpen = true;
            this.#cardTl.set(
                selectedCard.sizesW,
                { display: "flex", opacity: 1 },
                0
            );
            this.#cardTl.fromTo(
                selectedCard.pictureW,
                { x: 0 },
                {
                    x: () => -selectedCard.el.offsetWidth,
                    duration: 1,
                    ease: "power2.out"
                },
                0
            );
            this.#cardTl.fromTo(
                selectedCard.sizes,
                { x: () => selectedCard.el.offsetWidth },
                { x: 0, duration: 1, ease: "power2.out" },
                0
            );
            this.#cardTl.fromTo(
                selectedCard.contentTop,
                { opacity: 1 },
                { opacity: 0, duration: 0.5 },
                0
            );
            this.#cardTl.fromTo(
                selectedCard.sizesTop,
                { opacity: 0 },
                { opacity: 1, duration: 0.5 },
                0
            );
            this.#cardTl.set(selectedCard.content, {
                display: "none",
                opacity: 0
            });
        } else {
            selectedCard.isOpen = false;
            this.#cardTl.set(
                selectedCard.content,
                { display: "flex", opacity: 1 },
                0
            );
            this.#cardTl.fromTo(
                selectedCard.sizes,
                { x: 0 },
                {
                    x: () => selectedCard.el.offsetWidth,
                    duration: 1,
                    ease: "power2.out"
                },
                0
            );
            this.#cardTl.fromTo(
                selectedCard.pictureW,
                { x: () => -selectedCard.el.offsetWidth },
                { x: 0, duration: 1, ease: "power2.out" },
                0
            );
            this.#cardTl.fromTo(
                selectedCard.contentTop,
                { opacity: 0 },
                { opacity: 1, duration: 0.5 },
                0
            );
            this.#cardTl.fromTo(
                selectedCard.sizesTop,
                { opacity: 1 },
                { opacity: 0, duration: 0.5 },
                0
            );
            this.#cardTl.set(selectedCard.sizesW, {
                display: "none",
                opacity: 0
            });
        }

        if (this.#lastOpenCard && this.#lastOpenCard !== selectedCard) {
            this.#lastOpenCard.isOpen = false;
            this.#cardTl.set(
                this.#lastOpenCard.content,
                { display: "flex", opacity: 1 },
                0
            );
            this.#cardTl.fromTo(
                this.#lastOpenCard.sizes,
                { x: 0 },
                {
                    x: () => this.#lastOpenCard.el.offsetWidth,
                    duration: 1,
                    ease: "power2.out"
                },
                0
            );
            this.#cardTl.fromTo(
                this.#lastOpenCard.pictureW,
                { x: () => -this.#lastOpenCard.el.offsetWidth },
                { x: 0, duration: 1, ease: "power2.out" },
                0
            );
            this.#cardTl.fromTo(
                this.#lastOpenCard.contentTop,
                { opacity: 0 },
                { opacity: 1, duration: 0.5 },
                0
            );
            this.#cardTl.fromTo(
                this.#lastOpenCard.sizesTop,
                { opacity: 1 },
                { opacity: 0, duration: 0.5 },
                0
            );
            this.#cardTl.set(this.#lastOpenCard.sizesW, {
                display: "none",
                opacity: 0
            });
        }

        this.#lastOpenCard = selectedCard;

        this.#cardTl.add(() => {
            this.#isChanging = false;
        });
    };

    onItemClick = e => {
        this.itemsSize.forEach(size => {
            size.removeEventListener("click", this.onItemClick, true);
        });

        const item = e.currentTarget;
        dataLayer.push({
            event: "Choix du scénario",
            TypePiece: item.dataset.typeLabel,
            TypeScene: item.dataset.styleLabel,
            TypeTaille: item.dataset.sizeLabel
        });

        this.router.set(item.dataset.link);
    };
}

export { SizeAndStyle };
